var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sv_03 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9999 44.0002H29.9999C40 44.0002 43.9999 40.0002 43.9999 30.0003V18.0003C43.9999 8.00024 40 4.00024 29.9999 4.00024H17.9999C7.99989 4.00024 3.99988 8.00024 3.99988 18.0003V30.0003C3.99988 40.0002 7.99989 44.0002 17.9999 44.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M19.2 17.9399L14.22 22.9199C13.64 23.5 13.64 24.4799 14.22 25.06L19.2 30.04",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M28.7999 17.9399L33.7799 22.9199C34.3598 23.5 34.3598 24.4799 33.7799 25.06L28.7999 30.04",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopment);
export default __webpack_public_path__ + "static/media/web-development.f7bc4e2755f96d135eebc735ccb3db37.svg";
export { ForwardRef as ReactComponent };